import { Stack, styled, Typography } from '@mui/material';
import { PackageCard, PackageCardSkeleton, packagesModel } from 'entities/mine-package';
import { selectPackagesList } from 'entities/mine-package/model';
import { useLoadingState, useShallowSelector } from 'shared';

const PackagesGrid = styled('div')(({ theme }) => ({
  display: 'grid',
  columnGap: theme.spacing(2),
  rowGap: theme.spacing(2),
  gridTemplateColumns: 'repeat(1, 1fr)',

  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
    rowGap: theme.spacing(1.5),
  },
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(3, 1fr)',
  },
}));

const PackageCardLoaders = () => Array.from({ length: 6 }, (_, i) => <PackageCardSkeleton key={i} />);

export const PackagesList = () => {
  const packages = useShallowSelector(selectPackagesList);
  const [isInitialPackagesLoading] = useLoadingState(packagesModel.actionTypes.GET_INITIAL_PACKAGES);

  return (
    <Stack component="section" display="flex" gap={5} mt={{ xs: 6, sm: 10 }}>
      <Typography variant="h4" className="secondary">
        Mining Rig & Package Details
      </Typography>

      <PackagesGrid>
        {isInitialPackagesLoading && <PackageCardLoaders />}

        {!isInitialPackagesLoading &&
          packages.map((pkg) => (
            <PackageCard
              key={pkg.name}
              name={pkg.name}
              image={pkg.image}
              price={pkg.price}
              daily={pkg.daily}
              units={pkg.units}
            />
          ))}
      </PackagesGrid>
    </Stack>
  );
};
